import React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

function Footer() {
  return (
    <div className="footer__container">
      <section className="footer__bottom-line">
        <div className="footer__bottom-line-wrap">
          <Link to="/" className="footer__social-logo">
            <img className="footer__icon-image" src="images/icon.png" />
            Workom
          </Link>
          <div className="footer__link-row">
            <Link to="/company" className="footer__link">
              会社概要
            </Link>
            <a href="mailto:support@komms.co.jp" className="footer__link">
              お問い合わせ
            </a>
            <Link to="/privacy" className="footer__link">
              プライバシーポリシー
            </Link>
          </div>
        </div>
        <div className="footer__website-rights-wrap">
          <div className="footer__website-rights">
            Copyright © Workom All rights reserved.
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
